// SPDX-FileCopyrightText: 2017-2022 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import React from 'react'

import {
  daycareAssistanceLevels,
  preschoolAssistanceLevels
} from 'lib-common/generated/api-types/assistance'
import type { EmployeeCustomizations } from 'lib-customizations/types'
import { employeeConfig } from './appConfigs'
import MunicipalityLogo from './assets/municipality-logo-primary.svg'
import featureFlags from './featureFlags'

const customizations: EmployeeCustomizations = {
  appConfig: employeeConfig,
  translations: {
    fi: {
      common: {
        retroactiveConfirmation: {
          checkboxLabel:
            'Ymmärrän, olen asiasta yhteydessä laskutustiimiin vaka.maksut@suomussalmi.fi *'
        }
      },
      footer: {
        cityLabel: 'Suomussalmen kunta',
        linkLabel: 'Suomussalmen varhaiskasvatus',
        linkHref: 'https://www.suomussalmi.fi/fi/varhaiskasvatus-ja-koulutus/varhaiskasvatus'
      },
      unitEditor: {
        placeholder: {
          email: 'etunimi.sukunimi@suomussalmi.fi',
          url: 'esim. https://www.suomussalmi.fi/fi/toimipisteet/15585',
        }
      },
      welcomePage: {
        text: 'Olet kirjautunut sisään Suomussalmen kunnan eVaka-palveluun. Käyttäjätunnuksellesi ei ole vielä annettu oikeuksia, jotka mahdollistavat palvelun käytön. Tarvittavat käyttöoikeudet saat omalta esimieheltäsi.'
      },
      preferredFirstName: {
        description:
      'Voit määritellä eVakassa käytössä olevan kutsumanimesi. Kutsumanimen tulee olla jokin etunimistäsi. Jos nimesi on vaihtunut ja sinulla on tarve päivittää eVakaan uusi nimesi, ole yhteydessä Suomussalmen tukeen.',
      },
      login: {
        loginAD: 'Suomussalmen AD',
      },
      placement: {
        type: {
          PRESCHOOL_DAYCARE: 'Täydentävä varhaiskasvatus',
        },
      },
    },
    sv: {},
  },
  cityLogo: <img src={MunicipalityLogo} alt="Suomussalmi logo" data-qa="footer-city-logo" />,
  featureFlags,
  placementTypes: [
    'PRESCHOOL_DAYCARE',
    'DAYCARE',
    'DAYCARE_PART_TIME',
    'TEMPORARY_DAYCARE',
    'TEMPORARY_DAYCARE_PART_DAY',
    'SCHOOL_SHIFT_CARE',
  ],
  absenceTypes: [
    'OTHER_ABSENCE',
    'SICKLEAVE',
    'UNKNOWN_ABSENCE',
    'PLANNED_ABSENCE',
    'PARENTLEAVE',
    'FORCE_MAJEURE',
  ],
  daycareAssistanceLevels: [...daycareAssistanceLevels],
  otherAssistanceMeasureTypes: [
    'TRANSPORT_BENEFIT',
    'ACCULTURATION_SUPPORT',
    'ANOMALOUS_EDUCATION_START',
  ],
  placementPlanRejectReasons: ['REASON_1', 'REASON_2', 'OTHER'],
  preschoolAssistanceLevels: [...preschoolAssistanceLevels],
  unitProviderTypes: [
    'MUNICIPAL',
    'PURCHASED',
    'PRIVATE',
    'MUNICIPAL_SCHOOL',
    'PRIVATE_SERVICE_VOUCHER',
    'EXTERNAL_PURCHASED',
  ],
  voucherValueDecisionTypes: [
    'NORMAL',
    'RELIEF_ACCEPTED',
    'RELIEF_PARTLY_ACCEPTED',
    'RELIEF_REJECTED',
  ],
  additionalStaffAttendanceTypes: [
    'OTHER_WORK',
    'TRAINING',
    'JUSTIFIED_CHANGE',
    'SICKNESS',
    'CHILD_SICKNESS',
  ],

}

export default customizations
